import React from 'react'
import PropTypes from 'prop-types'

import Wrapper from './BurgerMenu.styles'

const BurgerMenu = ({ handleNavbar }) => (
  <Wrapper onClick={handleNavbar}>
    <span>&nbsp;</span>
    <span>&nbsp;</span>
    <span>&nbsp;</span>
  </Wrapper>
)

BurgerMenu.propTypes = {
  handleNavbar: PropTypes.func.isRequired,
}

export default BurgerMenu
